var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgMobileVoucher20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 1.25h10c.458 0 .833.375.833.833v1.25H4.166v-1.25c0-.458.375-.833.833-.833ZM4.166 15.833h11.667v1.25a.836.836 0 0 1-.834.833H5a.836.836 0 0 1-.833-.833v-1.25Z",
  fill: "#A4AEBA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.833 3.333H4.166v12.5h11.667v-12.5Z",
  fill: "#D3D9DF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.024 10.417a1.607 1.607 0 1 1 0 3.214 1.607 1.607 0 0 1 0-3.214Zm.634-3.711a.417.417 0 0 1 .59.589l-5.953 5.952a.417.417 0 0 1-.59-.59l5.953-5.951Zm-.634 4.544a.774.774 0 1 0 0 1.548.774.774 0 0 0 0-1.548Zm-4.167-5a1.607 1.607 0 1 1 0 3.215 1.607 1.607 0 0 1 0-3.215Zm0 .833a.774.774 0 1 0 0 1.548.774.774 0 0 0 0-1.548Z",
  fill: "#5B6A81"
})));
export default SvgImgMobileVoucher20X20;